import { Link } from 'gatsby';
import * as React from 'react';
import breakpoint from 'styled-components-breakpoint';
import styled from '../../styled-components';
import { Container } from '../Grid';

const Footer = styled.footer`
  position: absolute;
  bottom: 0;
  width: 100%;
  min-height: 100px;
  padding-bottom: 20px;
  margin-top: ${props => props.theme.baseMargin * 2}rem;
  background-color: ${props => props.theme.headerBackgroundColor};
  color: ${props => props.theme.mutedColor};

  ${props => breakpoint('md')`
      min-height: 80px;
`};
`;

const FooterText = styled.p`
  margin-bottom: 0;
  font-size: 90%;
  font-weight: 300;
  margin-top: 0;
  padding-bottom: 0;
  padding-top: ${props => props.theme.baseMargin}rem;
  line-height: ${props => props.theme.baseLineHeight};
  overflow: hidden;

  ${props => breakpoint('md')`
      padding-top: ${props.theme.baseMargin}rem;
`};
`;

const SiteFooter = () => (
  <Footer>
    <Container>
      <FooterText>
        Copyright 2018 <Link to="/">RBV Energy</Link> | All rights reserved |
        Created by Andrew Bain
      </FooterText>

      {/* Certification Badges Container */}
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '20px', marginTop: '15px' }}>
        
        {/* Certificate 1 */}
        <img 
          src="https://images.ctfassets.net/1ax1cnysdt5j/4yLEG5EJpNLtnphdy985ZS/ed6bcffc52e6d3c29a06e2385bd0b8ee/ISO-9001-2015-badge-white.png?h=250" 
          alt="ISO 9001 Certified by QMS" 
          style={{ width: '200px', height: 'auto' }} 
        />

        {/* Certificate 2 */}
        <img 
          src="https://images.ctfassets.net/1ax1cnysdt5j/5ZtVdZedo1dHO1GUeJYt9N/40fa991d1bb16d8e246b29308fce05f1/ISO-14001-2015-badge-white.png?h=250" 
          alt="ISO 14001 Certified by QMS" 
          style={{ width: '200px', height: 'auto' }} 
        />

        {/* Certificate 3 */}
        <img 
          src="https://images.ctfassets.net/1ax1cnysdt5j/4FBgNPg6nLXcZNaKfF7DcQ/6212e766db05a9ee80aaf066d0fc023f/ISO-45001-2018-badge-white.png?h=250" 
          alt="ISO 45001 Certified by QMS" 
          style={{ width: '200px', height: 'auto' }} 
        />

      </div>
    </Container>
  </Footer>
);

export default SiteFooter;
